/* eslint-disable @typescript-eslint/no-use-before-define */
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BottomSheetScrollView } from '@gorhom/bottom-sheet';
import { memo, ReactNode } from 'react';
import { Platform, ScrollView, ScrollViewProps } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useSiteInspectionNavigatorContext } from '../SiteInspectionContext';

export const ScrollViewContainer = memo(
  ({
    bottomSpacing,
    children,
    contentContainerStyle,
    ...props
  }: {
    bottomSpacing?: number;
    children?: ReactNode;
  } & ScrollViewProps) => {
    const { rpx } = useResponsiveContext();
    bottomSpacing = bottomSpacing ?? rpx(68);
    const safeAreaInsets = useSafeAreaInsets();
    const { navigatorContainerType } = useSiteInspectionNavigatorContext();

    // Fix: BottomSheet specific scroll view components do not work on Web right now.
    // https://github.com/gorhom/react-native-bottom-sheet/issues/11
    const ScrollComponent =
      Platform.OS === 'web' ? ScrollView : BottomSheetScrollView;

    if (navigatorContainerType === 'bottomsheet') {
      return (
        <ScrollComponent
          showsVerticalScrollIndicator={false}
          keyboardShouldPersistTaps="handled"
          contentContainerStyle={[
            {
              paddingBottom: safeAreaInsets.bottom + bottomSpacing,
            },
            contentContainerStyle,
          ]}
          {...props}
        >
          {children}
        </ScrollComponent>
      );
    }

    return (
      <ScrollView
        showsVerticalScrollIndicator={Platform.OS === 'web'}
        keyboardShouldPersistTaps="handled"
        contentContainerStyle={[
          {
            paddingBottom: bottomSpacing,
          },
          contentContainerStyle,
        ]}
        {...props}
      >
        {children}
      </ScrollView>
    );
  },
);
